import logo from './logo.svg';
import './App.css';
import React from 'react';
import { Routes, Route } from "react-router-dom"; 
import HomePage from './pages/HomePage';
import PreviewPage from './pages/PreviewPage';
import Stats from './pages/Stats';


function App() {
  return (
    <div className="App">
     
     <Routes>
       
        <Route path="/" element={<HomePage />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/stats" element={<Stats />} /> 
     </Routes>
    </div>
  );
}

export default App;
